import { createSelector } from '@reduxjs/toolkit';
import { mapCancellationPoliciesByCancellation, mapCancellationTypeByCancellation } from 'gql/service/graph/activityService';
import { CancellationType } from 'gql/autogen/CancellationType';
import { sortCancellationPolicies } from 'component/page/detail/CancellationPolicyCard/cancellationUtil';
import { CancellationPolicy } from 'gql/autogen/CancellationPolicy';
import { selectActivityRepresentativeInfo } from 'component/page/detail/store/detail.selectors';

export interface CancellationPolicyCardProps {
    cancellationType: CancellationType;
    sortedPolicies: CancellationPolicy[];
}

export const mapCancellationPolicyCardProps = createSelector(selectActivityRepresentativeInfo, (representativeInfo): CancellationPolicyCardProps => {
    const cancellationType = mapCancellationTypeByCancellation(representativeInfo?.cancellationPolicy);
    const policies = mapCancellationPoliciesByCancellation(representativeInfo?.cancellationPolicy);
    const sortedPolicies = sortCancellationPolicies(policies);

    return { cancellationType, sortedPolicies };
});
